/**
 * @author        quanquan
 * @dateTime      2020-12-09 14:14:54
 * @description   meituanIM
 */
import MC from '@/module/MC'
import meituanIM from '@/module/apis/meituanIM'
import nameMap from './nameMap'
import { findComponentsDownward } from '@/module/utils'
import { decMsg, timeUnix } from '@/module/components/mtIm/_source/utils'
import { handlerMsgItem, handlerSelfMsgItem, tooltipNotify } from './utils'

export default {
  /**
   * Get store data
   */
  getStoreData ({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      meituanIM.getStoreList({ currentPage: 1, pageSize: 1000, storeName: '' }).then(res => {
        const { data } = res
        if (!_.isEmpty(data)) {
          commit('setMtImStoreData', data)
          const item = _.head(data)
          const p = _.pick(item, ['onlineClientCode', 'onlineStoreCode'])
          commit('setUserSearchParams', p)
          commit('setStoreSearchParams', p)
          dispatch('getUserData', p)
        }
        resolve(data)
      }).catch(e => {
        reject(e)
      })
    })
  },
  /**
   * Get users data
   */
  getUserData ({ state, commit, dispatch }, payload) {
    const p = {
      currentPage: 1,
      onlineClientCode: '',
      onlineStoreCode: '',
      pageSize: 1000,
      ...payload
    }
    return new Promise((resolve, reject) => {
      meituanIM.getStoreUsers(p).then(res => {
        const { data } = res

        if (_.isEmpty(state.cacheSingleMsg)) {
          // cache user data
          commit('setMtImUserData', data)
        } else {
          // new add cache user data
          commit('setMtImUserData', [state.cacheSingleMsg, ...data])
          // clean up data
          commit('setCacheSingleMsg', {})
        }

        if (!_.isEmpty(data)) {
          const { thirdUserId, onlineStoreCode } = _.head(state.mtImUserData)
          const p = { thirdUserId, onlineStoreCode }
          commit('setMsgSearchParams', p)
          dispatch('$reportNum', p)
        }
        resolve(data)
      }).catch(e => {
        reject(e)
      })
    })
  },
  /**
   * Report chat data
   */
  $pushChatMsg ({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      meituanIM.messageIMReport({
        stores: payload
      }).then(res => {
        console.log('[meituanIM] => 消息上报成功')
      })
    })
  },
  /**
   * Report chat data
   */
  $pushMessage ({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      meituanIM.messageIMReport({
        stores: state.cacheStoresData
      }).then(() => {
        console.log('[meituanIM] => 消息上报成功-', state.cacheStoresData)
        commit('setCacheStoresData', _.drop(state.cacheStoresData, 3))
        console.log('[meituanIM] => 清除上报数据成功-', state.cacheStoresData)
        resolve()
      }).catch((e) => {
        console.log('[meituanIM] => 消息上报失败-', state.cacheStoresData)
        reject(e)
      })
    })
  },
  /**
   * Report a single chat record
   */
  $pushSendChatMsg ({ state, commit, dispatch }, payload) {
    const { msg_content, cts, msg_type, open_user_id } = payload.msgItemPayload
    const { onlineStoreCode, onlineClientCode } = state.storeSearchParams
    const fStore = _.find(state.mtImStoreData, ['onlineStoreCode', onlineStoreCode])
    let fUser = _.find(state.mtImUserData, ['thirdUserId', open_user_id])
    const { appSecret } = _.find(state.cacheAppSecret, ['onlineClientCode', onlineClientCode])
    const { merCode } = MC.config.userInfo

    const msgItem = handlerMsgItem({
      msgContent: msg_content,
      appSecret,
      payloadItem: payload.msgItemPayload,
      merCode
    })

    const userItem = {
      ..._.pick(fUser, ['id', 'merCode', 'onlineClientCode', 'onlineStoreCode', 'userId', 'thirdUserId', 'userName', 'userLogo']),
      newRecord: false,
      lastMsgSource: 1,
      lastMsg: decMsg(msg_content, appSecret),
      lastMsgTime: timeUnix(cts),
      lastMsgType: msg_type,
      unreadMsgCount: 0,
      msgList: [msgItem]
    }

    const storeItem = {
      ..._.pick(fStore, ['id', 'lastMsgTime', 'onlineClientCode', 'onlineStoreCode']),
      unreadMsgCount: _.sum(_.map(state.mtImUserData, 'unreadMsgCount')),
      users: [userItem]
    }
    state.mtImUserData = _.reject(state.mtImUserData, ['thirdUserId', open_user_id])
    state.mtImUserData.unshift(userItem)
    commit('setCacheStoresItemData', storeItem)
  },
  /**
   * report
   */
  async $messageProcessing ({ state, commit, dispatch }, payload) {
    // {
    //   "msg_content": "UAZkjnrmYCj8EpVcbR591w==",
    //   "msgTraceId": 3372069078116740413,
    //   "msg_type": 1,
    //   "app_poi_code": "t_Tyk0nlpSNh",
    //   "msg_id": 1032528976660045824,
    //   "app_id": 4692,
    //   "msg_source": 2,
    //   "order_id": 0,
    //   "cts": 1607927830,
    //   "open_user_id": 10847911286
    // }
    const { msgItemPayload } = payload
    const { app_poi_code, open_user_id, msg_content, msg_source, msg_type, cts } = msgItemPayload
    let fStore = _.find(state.mtImStoreData, ['onlineStoreCode', app_poi_code])

    // 是否存在门店
    if (!_.isEmpty(fStore)) {
      const { merCode } = MC.config.userInfo
      const { onlineClientCode, onlineStoreCode } = fStore
      let isUser = _.find(state.mtImUserData, ['thirdUserId', `${open_user_id}`])
      const { appSecret } = _.find(state.cacheAppSecret, ['onlineClientCode', onlineClientCode])
      const isCurrentChatPartner = state.msgSearchParams.thirdUserId === `${open_user_id}`
      const lastMsg = decMsg(msg_content, appSecret)
      const lastMsgTime = timeUnix(cts)

      // 当前聊天记录Item
      let itemMsg = handlerMsgItem({ msgContent: msg_content, payloadItem: msgItemPayload, appSecret, merCode })

      // 当前相关用户Item
      let itemUser = {
        merCode,
        onlineClientCode,
        onlineStoreCode,
        lastMsg,
        lastMsgTime,
        lastMsgSource: msg_source,
        lastMsgType: msg_type,
        thirdUserId: `${open_user_id}`,
        newRecord: false,
        unreadMsgCount: 1,
        userId: '',
        userLogo: '',
        userName: ''
      }

      const handlerUserItem = (itemUserData) => {
        if (_.isEmpty(itemUserData)) {
          return {
            ...itemUser,
            userId: `${open_user_id}`,
            userName: `${_.sample(nameMap)}_${open_user_id}`,
            newRecord: true,
            msgList: [itemMsg]
          }
        }
        return _.assign(itemUser, {
          ..._.pick(itemUserData, ['userId', 'userLogo', 'userName']),
          unreadMsgCount: (() => {
            if (state.msgSearchParams.thirdUserId === `${open_user_id}`) {
              return 0
            } else {
              return itemUserData.unreadMsgCount + 1
            }
          })(),
          msgList: [itemMsg]
        })
      }

      if (_.isEmpty(isUser)) {
        const usp = { onlineStoreCode, thirdUserId: `${open_user_id}` }
        const data = await meituanIM.getSingleUser(usp)
        itemUser = handlerUserItem(data)
        // 无相关用户则定义默认规则用户数据
        if (_.isEmpty(data)) {
          itemUser = { ...itemUser, unreadMsgCount: 0 }
          commit('setMtImUserItem', itemUser)
          commit('setUserSearchParams', { onlineClientCode, onlineStoreCode })
          commit('setMsgSearchParams', usp)
          // 缓存当前聊天内容
          commit('setCacheCurrentChatBoxMsg', { ...handlerSelfMsgItem(itemMsg), merCode, msgContent: lastMsg })
        }
      } else {
        itemUser = handlerUserItem(isUser)
      }

      isUser = _.assign(isUser, itemUser)

      // 当前相关门店Item
      const itemStore = { ..._.pick(fStore, ['id', 'onlineClientCode', 'onlineStoreCode']),
        lastMsgTime,
        unreadMsgCount: (() => {
          if (state.msgSearchParams.thirdUserId === `${open_user_id}`) {
            return Number(isUser.unreadMsgCount) < 0
              ? 0
              // : Number(fStore.unreadMsgCount) - Number(isUser.unreadMsgCount)
              : _.sum(_.map(state.mtImUserData, 'unreadMsgCount'))
          } else {
            return Number(fStore.unreadMsgCount) + 1
          }
        })(),
        users: [itemUser]
      }

      fStore = _.assign(fStore, itemStore)

      // 缓存上报单条数据
      commit('setCacheStoresItemData', itemStore)

      // 存储到当前聊天框
      if (isCurrentChatPartner) {
        commit('setSingleMtImMsgData', { ...handlerSelfMsgItem(itemMsg), merCode, msgContent: lastMsg })
        const instance = findComponentsDownward(payload.$root, 'vi-cs-content')
        !_.isEmpty(instance) && instance[0].onScroll('bottom')
      }
      // 提示
      tooltipNotify(msg_type, lastMsg)
    } else {
      console.error('[meituanIM] => 无相关门店，请同步门店设置')
    }
  },
  /**
   * Individually reported quantity
   */
  $reportNum ({ state, commit, dispatch }, payload) {
    const { thirdUserId, onlineStoreCode } = payload
    let fStore = _.find(state.mtImStoreData, ['onlineStoreCode', onlineStoreCode])
    let fUser = _.find(state.mtImUserData, ['thirdUserId', thirdUserId])

    if (fUser.unreadMsgCount !== 0) {
      fStore.unreadMsgCount = Number(fStore.unreadMsgCount) - Number(fUser.unreadMsgCount)
      fUser.unreadMsgCount = 0
      const stores = [
        {
          ..._.pick(fStore, ['id', 'unreadMsgCount']),
          users: [
            {
              ...fUser,
              newRecord: false
            }
          ]
        }
      ]
      meituanIM.unreadMsgReport({ stores }).then(() => {
        console.log('[meituanIM] => 处理阅读数成功')
      }).catch(() => {
        console.log('[meituanIM] => 处理阅读数失败')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/meituanIM/actions.js